import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./navbar.css";
import logo from "../../assets/logo.jpg";
import Popupboxbox from '../popupbox/Popupbox'; 
import Sideicons from '../../sideicons/Sideicons';

function Navbar() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handles standard routing paths (e.g., Home page, Course pages)
  const handleCourseClick = (e, path) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    setIsMobileDropdownOpen(false);
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Instantly resets scroll position on view shift
  };

  // Handles same-page and cross-page anchor scrolling
  const handleAnchorClick = (e, targetId) => {
    e.preventDefault();
    setIsMobileMenuOpen(false); 
    setIsMobileDropdownOpen(false);

    // If already on the homepage, scroll down immediately
    if (window.location.pathname === '/') {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on an inner/course page, return home first, then scroll
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300); // 300ms delay to allow DOM mapping to finish mounting
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileDropdown = (e) => {
    if (window.innerWidth <= 992) {
      e.preventDefault();
      setIsMobileDropdownOpen(!isMobileDropdownOpen);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav className={`fz-navbar-container ${scrolled ? "navbarr-scrolled" : ""}`}>
        {/* Brand Logo */}
        <div
          className="fz-logo-wrapper"
          onClick={() => { navigate('/'); setIsMobileMenuOpen(false); }}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <a href='/' onClick={(e) => e.stopPropagation()}>
            <img src={logo} alt="Fazo Academy Logo" className='nav-image' />
          </a>
        </div>

        {/* Hamburger / Close Toggle Button */}
        <button
          className={`fz-mobile-toggle-btn ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
        >
          {isMobileMenuOpen ? (
            <span className="fz-close-icon">✕</span>
          ) : (
            <div className="fz-hamburger-bars-group">
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
            </div>
          )}
        </button>

        {/* Side Drawer Background Backdrop */}
        {isMobileMenuOpen && (
          <div className="fz-nav-sidebar-overlay" onClick={toggleMobileMenu}></div>
        )}

        {/* Navigation Links Side Box Drawer */}
        <div className={`fz-nav-links-box ${isMobileMenuOpen ? 'show' : ''}`}>
          <a href="/" onClick={(e) => handleCourseClick(e, "/")} className="fz-nav-item fz-active">Home</a>
          
          <a href="#aboutsection" onClick={(e) => handleAnchorClick(e, "aboutsection")} className="fz-nav-item">About</a>

          {/* Training Programs Dropdown Parent */}
          <div className={`fz-nav-item fz-dropdown-root ${isMobileDropdownOpen ? 'submenu-open' : ''}`}>
            <div className="fz-dropdown-trigger" onClick={toggleMobileDropdown}>
              <span>Training Programs</span>
              <span className="fz-dropdown-arrow-icon">▼</span>
            </div>

            {/* Dropdown Content Links */}
            <div className="fz-dropdown-menu-card">
              <a href="/software-testing-in-chennai" onClick={(e) => handleCourseClick(e, "/software-testing-in-chennai")} className="fz-dropdown-item-link">Software Testing Course</a>
              <a href="/java-course-in-chennai" onClick={(e) => handleCourseClick(e, "/java-course-in-chennai")} className="fz-dropdown-item-link">Java Full Stack Course</a>
              <a href="/python-course-in-chennai" onClick={(e) => handleCourseClick(e, "/python-course-in-chennai")} className="fz-dropdown-item-link">Python Course</a>
              <a href="/dotnet-course-in-chennai" onClick={(e) => handleCourseClick(e, "/dotnet-course-in-chennai")} className="fz-dropdown-item-link">.Net Course</a>
              <a href="/devops-course-in-chennai" onClick={(e) => handleCourseClick(e, "/devops-course-in-chennai")} className="fz-dropdown-item-link">DevOps Course</a>
              <a href="/aws-course-in-chennai" onClick={(e) => handleCourseClick(e, "/aws-course-in-chennai")} className="fz-dropdown-item-link">AWS Course</a>
              <a href="/azure-course-in-chennai" onClick={(e) => handleCourseClick(e, "/azure-course-in-chennai")} className="fz-dropdown-item-link">Azure Course</a>
              <a href="/uiux-course-in-chennai" onClick={(e) => handleCourseClick(e, "/uiux-course-in-chennai")} className="fz-dropdown-item-link">UI/UX Course</a>
              <a href="/ai-course-in-chennai" onClick={(e) => handleCourseClick(e, "/ai-course-in-chennai")} className="fz-dropdown-item-link">Artificial Intelligence Course</a>
              <a href="/datascience-course-in-chennai" onClick={(e) => handleCourseClick(e, "/datascience-course-in-chennai")} className="fz-dropdown-item-link">Data Science</a>
              <a href="/analist-course-in-chennai" onClick={(e) => handleCourseClick(e, "/analist-course-in-chennai")} className="fz-dropdown-item-link">Data Analysis</a>
              <a href="/frontend-course-in-chennai" onClick={(e) => handleCourseClick(e, "/frontend-course-in-chennai")} className="fz-dropdown-item-link">Front End Developer</a>
            </div>
          </div>

          <a href="#contact-section" onClick={(e) => handleAnchorClick(e, "contact-section")} className="fz-nav-item">Contact Us</a>

          <div className="fz-mobile-cta-wrapper">
            <button className="fz-enquiry-cta-btn" onClick={() => { setIsMobileMenuOpen(false); setShowModal(true); }}>
              Enquiry Now
            </button>
          </div>
        </div>

        {/* Desktop Layout CTA Button */}
        <div className="fz-desktop-cta-wrapper">
          <button className="fz-enquiry-cta-btn" onClick={() => setShowModal(true)}>
            Enquiry Now
          </button>
        </div>
      </nav>

      <Sideicons />
      <Popupboxbox isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default Navbar;